<nz-skeleton [nzActive]="true" [nzLoading]="loading">
  <div *ngIf="infoMatch.statusId > 1 && matchSummary">
    <ng-container *ngFor="let match of matchSummary">
      <div
        class="bg-red-4 font-roboto-500 text-16 rounded-5 py-3 text-grey-1 mb-3 max-sm:text-13 mt-5 max-sm:mt-2 text-center"
        text-center
      >
        {{ match.title | translate }}
      </div>

      <div class="flex justify-around font-roboto-600 text-16 text-grey-2">
        <span>{{ match.homeTeamScore }}</span>
        <span>{{ match.awayTeamScore }}</span>
      </div>
    </ng-container>
  </div>
</nz-skeleton>